export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/index.592e468c.worker.js");
}
